import { Component, OnInit, Input } from '@angular/core';
import { Product } from '@models/product';

@Component({
  selector: 'gob-list-card',
  templateUrl: './list-card.component.html',
  styleUrls: ['./list-card.component.scss']
})
export class ListCardComponent implements OnInit {
  @Input() products: Product[]=[];

  constructor() { }

  ngOnInit(): void {
  }
}
